module.exports = __webpack_public_path__ + "static/media/55840540_2519320791476430_1033812281848233984_o.2f962b82.jpg";